<template>
  <main
    class="bg-white min-h-screen col-start-1 pl-4 md:pl-8 lg:pl-0 lg:col-start-3 col-end-13 relative z-10"
    v-if="news"
  >
    <grid-letters text="news" />
    <div class="relative z-10 md:pt-4 pb-8">
      <news-item
        v-for="(item, index) in news.data"
        :key="item.uid"
        :item="item"
        :index="index"
      />
      <div v-if="busy" class="p-4 ta-c">Loading more</div>
      <div class="h-screen"></div>
    </div>
  </main>
</template>

<script>
import GridLetters from "@/components/GridLetters.vue";
import NewsItem from "@/components/NewsItem.vue";
import { mapState } from "vuex";
export default {
  name: "news",
  metaInfo: {
    title: "– News",
  },
  components: {
    GridLetters,
    NewsItem,
  },
  data() {
    return {
      busy: false,
    };
  },
  computed: mapState(["news"]),
  methods: {
    loadMore() {
      this.busy = true;
      let curPage = this.news.pagination.page;
      if (curPage < this.news.pagination.pages) {
        this.$store.dispatch("loadNews", curPage + 1).then(() => {
          this.busy = false;
        });
      } else {
        this.busy = false;
      }
    },
    changeCursor(name) {
      this.$root.$emit("changeCursor", name);
    },
  },
};
</script>
